import versionFile from '../assets/version.json';

export const environment = {
  production: true,
  version: versionFile.version,
  cognito: {
    userPoolId: 'eu-central-1_DMyu5sxN5',
    userPoolWebClientId: '69sgi04jvh4kvgoslpijf7uugl',
    oauth: {
      domain: 'inwedio.auth.eu-central-1.amazoncognito.com',
      redirectSignIn: `${window.location.origin}`,
      redirectSignOut: `${window.location.origin}/signIn`,
      clientId:
        '308486427799-ohn1b558kpgejft8ha9r4vf179ncjt2t.apps.googleusercontent.com',
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
};
